import { Sidebar } from './Sidebar';
import { ExportPdfButton } from './ExportPdfButton';
import css from './AppShell.module.css';

export function AppShell({ children }: { children: React.ReactNode }) {
  return (
    <div className={css.shell}>
      <a className="skip-link" href="#main">Skip to main content</a>
      <div data-print-hidden="true">
        <Sidebar />
      </div>
      <main id="main" className={css.main}>
        <div className={css.utilityBar} data-print-hidden="true">
          <ExportPdfButton />
        </div>
        <div className={css.content}>
          {children}
        </div>
      </main>
    </div>
  );
}
